export enum BOMViewType {
  INGREDIENT = "ingredient",
  CHEMICAL = "chemical"
}
